import AuthContext from "context/AuthContext";
import { isEmpty } from "lodash";
import { useCallback, useEffect } from "react";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiDelete, apiGet } from "utils/apiFetch";
import apiPath from "utils/apiPath";
import { Link, useNavigate } from "react-router-dom";
import { TiPencil, TiPlus, TiTrash } from "react-icons/ti";
import useToastContext from "hooks/useToastContext";
import Fab from "pages/test_manager/components/Fab";

export default function QuestionBankPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const permissions = user?.permission?.find(
    (e) => e.manager === "test_manager",
  );
  const [questionBanks, setQuestionBanks] = useState([]);
  const notification = useToastContext();

  const fetchQuestionBanks = useCallback(
    async function fetchQuestionBanks() {
      try {
        const path = apiPath.quizQuestionBank;
        const result = await apiGet(path);
        setQuestionBanks(result?.data?.results?.docs);
      } catch (error) {
        console.log(error);
        notification.error(error?.response?.data?.message);
      }
    },
    [notification],
  );
  useEffect(() => {
    fetchQuestionBanks();
  }, [fetchQuestionBanks]);

  async function deleteQuestionBankHandler(questionBankId) {
    const path = apiPath.quizQuestionBank + "/" + questionBankId;
    try {
      const result = await apiDelete(path);
      if (result?.data?.success) {
        setQuestionBanks(questionBanks.filter((q) => q._id !== questionBankId));
      }
    } catch (error) {
      console.log(error);
      notification.error(t("O_SOMETHING_WENT_WRONG"));
    }
  }
  return (
    <div className="bg-white px-2 py-4 flex flex-col gap-4">
      <h1 className="text-2xl font-bold">{t("O_QUESTION_BANK")}</h1>

      {(permissions?.add || user?.role === "admin") && (
        <Fab onClick={() => navigate("/test-manager/question-bank/add")}>
          <TiPlus /> Create Question Bank
        </Fab>
      )}
      <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
        <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" className="py-3 px-6 border-l">
              #
            </th>
            <th scope="col" className="py-3 px-6 border-l">
              {t("O_TITLE")}
            </th>
            <th scope="col" className="py-3 px-6 border-l">
              {t("O_DESCRIPTION")}
            </th>
            <th scope="col" className="py-3 px-6 border-l">
              {t("O_QUESTIONS")}
            </th>
            <th scope="col" className="py-3 px-6 border-l">
              {t("O_ACTION")}
            </th>
          </tr>
        </thead>
        <tbody>
          {questionBanks.map((questionBank, index) => (
            <tr className="border-b border-[#E1E6EE]" key={index}>
              <td className="py-3 px-6 border-l">{index + 1}</td>
              <td className="py-3 px-6 border-l">{questionBank.title}</td>
              <td className="py-3 px-6 border-l">{questionBank.description}</td>
              <td className="py-3 px-6 border-l">
                <Link
                  className="text-green-400 hover:text-green-700 font-bold"
                  to={`/test-manager/questions?questionBankId=${questionBank._id}`}
                >
                  {questionBank?.questionCount || 0}
                </Link>
              </td>
              <td className="py-3 px-6 flex gap-2 items-center justify-center">
                {(permissions?.add || user?.role === "admin") && (
                  <button
                    className="bg-red-500 text-white p-1 rounded-full"
                    onClick={() => deleteQuestionBankHandler(questionBank._id)}
                  >
                    <TiTrash size={16} className="text-white" />
                  </button>
                )}
                {(permissions?.add || user?.role === "admin") && (
                  <button className="bg-blue-500 text-white p-1 rounded-full">
                    <TiPencil size={16} />
                  </button>
                )}
              </td>
            </tr>
          ))}
          {isEmpty(questionBanks) && (
            <tr>
              <td colSpan={5} className="py-3 px-6 text-center w-full">
                {t("O_NO_RECORD_FOUND")}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
